import * as actionTypes from './actionTypes';
import { loginService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';
import { fetchValidateAccess } from '@app/src/common/session';

const isClient = isClientEnv();

const fetchLoginRequest = () => ({
  type: actionTypes.FETCH_LOGIN_REQUEST
});

const fetchLoginFailure = () => ({
  type: actionTypes.FETCH_LOGIN_FAILURE
});

const fetchLoginSuccess = (data) => ({
  type: actionTypes.FETCH_LOGIN_SUCCESS,
  data
});

export const clearLoginData = () => ({
  type: actionTypes.CLEAR_LOGIN_DATA
});

export const fetchLogin = (json, token: string) => {
  return async dispatch => {
    dispatch(fetchLoginRequest());
    await dispatch(fetchValidateAccess());
    try {
      json.token = token;
      const data = await loginService.post(json);
      if (data.error && data.data && data.data.length === 0) {
        dispatch(actionsModalError.openModalError(data.message));
        dispatch(fetchLoginFailure());
      } else {
        const currentData = data.data[0];
        dispatch(fetchLoginSuccess(currentData));
        const user = JSON.parse(localStorage.getItem('user'));
        const updateUser = {
          ...user,
          jwt: currentData && currentData.jwt
        }
        if (isClient) {
          localStorage.setItem('user', JSON.stringify(updateUser));
        }
      }
    } catch (error) {
      console.log(`Error fetch login action ${error}`);
      dispatch(actionsModalError.openModalError('Ocurrió un error'));
      dispatch(fetchLoginFailure());
    }
  }
}
